'use client';

import { useRef, useEffect } from 'react';

function useClickAway(handler, options) {
    var _a = options || {}, nodeRefs = _a.nodeRefs, _b = _a.event, event = _b === void 0 ? 'mouseup' : _b;
    var ref = useRef(null);
    useEffect(function () {
        var listener = function (e) {
            var target = (e !== null && e !== void 0 ? e : {}).target;
            if (Array.isArray(nodeRefs)) {
                var shouldIgnore = !document.body.contains(target) && target.tagName !== 'HTML';
                var shouldTrigger = nodeRefs.every(function (ref) {
                    if (ref.current) {
                        return !e.composedPath().includes(ref.current);
                    }
                    return false;
                });
                shouldTrigger && !shouldIgnore && handler();
            }
            else {
                if (ref.current && !ref.current.contains(target)) {
                    handler();
                }
            }
        };
        document.addEventListener(event, listener, { passive: true });
        return function () {
            document.removeEventListener(event, listener);
        };
    }, [event, handler, nodeRefs]);
    return ref;
}

export { useClickAway as default };
//# sourceMappingURL=useClickAway.js.map
